import { Flex, Text, Box, Icon, Link } from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

export const Footer = () => {
  return (
    <Box>
      <Flex
        align={"center"}
        justify={{ base: "space-between", lg: "center" }}
        gap={"90px"}
        mb="37px"
        fontFamily={"Raleway"}
      >
        <Link fontSize={"16px"} fontWeight={600} color={"#0C111D"} href="/">
          Home
        </Link>

        <Link
          fontSize={"16px"}
          fontWeight={600}
          color={"#0C111D"}
          href="/about"
        >
          About
        </Link>

        <Link
          fontSize={"16px"}
          fontWeight={600}
          color={"#0C111D"}
          href="/events"
        >
          Events
        </Link>
      </Flex>

      <Flex mb="37px" justify={"center"}>
        <Icon
          size="xl"
          color={"#98A2B3"}
          cursor={"pointer"}
          onClick={() =>
            window.open(
              "https://www.linkedin.com/in/udobong-ntia-b171871?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
              "_blank"
            )
          }
        >
          <FaLinkedin />
        </Icon>
      </Flex>

      <Text
        fontSize={"16px"}
        fontWeight={600}
        color={"#0C111D"}
        textAlign={"center"}
        fontFamily={"Raleway"}
      >
        © 2025 Udy Ntia
      </Text>
    </Box>
  );
};
